import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./installations/routes/AppRoutingProvider";
import HeaderComponent from "./components/layouts/header/HeaderComponent";
// import FooterComponent from "./components/layouts/footer/FooterComponent";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DialogManagerComponent from "./components/dialogs/DialogManagerComponent";
import FooterComponent from "./components/layouts/footer/FooterComponent";
import { queryClient } from "./middlewares/cacheing/QueryClient.middleware";
import ScrollToTop from "./hooks/useScrollToTop";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="appLayoutContainer">
        <HeaderComponent />
        <div className="container">
          <ScrollToTop /> {/* Ensures all page changes scroll to top */}
          <AppRoutes />
        </div>
        <FooterComponent />
      </div>
      <DialogManagerComponent />
    </QueryClientProvider>
  );
}

export default App;
